import {ComponentsByEntityId, AlarmsConfigsInterface, IAlarmsGrid} from '../services/graphqlApi.service';
import { TagAlarm } from 'app/shared/alarms/intefaces/intefaces';

export function getAlarm(alarm: AlarmsConfigsInterface) {
  const eventConfig = alarm[0];
  return {
    autoAck: alarm.auto_ack,
    componentId: alarm.component_id,
    conditionType: alarm.condition_type,
    groupName: alarm.group_name,
    id: alarm.id,
    isDeleted: alarm.is_deleted,
    isOverride: alarm.event_config?.is_override,
    parentConfigId: alarm.event_config?.parent_config_id,
    latch: alarm.latch,
    message: alarm.message,
    rangeMax: alarm.range_max,
    rangeMin: alarm.range_min,
    reAlarm: alarm.re_alarm,
    recommendedAction: alarm.recommended_action,
    rocValue: alarm.roc_value,
    setpoint: alarm.setpoint,
    severity: alarm.severity,
    tagId: alarm.tag_id,
    tagName: alarm.tag?.name,
    time: alarm.time,
    createdOn: alarm.created_date,
    updatedOn: alarm.updated_date,
    name: alarm.event_config?.name,
    description: alarm.event_config?.description,
    eventConfigId: alarm.event_config?.id,
    eventConfigType: alarm.event_config?.event_config_type,
    isEnabled: alarm.event_config?.is_enabled || false
  };
}

/**
 * set alarms view model for grid (from view query)
 * @param alarm alarm
 */
export function setAlarmForGridView(alarms: any): TagAlarm[] {
  console.log('alarms: ', alarms);
const assetAlarms: TagAlarm[] = [];
  alarms?.forEach(alarm => {
    const objAlarmsGrid: TagAlarm = {
      autoAck: alarm.autoAck,
      componentId: alarm.componentId,
      componentName: alarm.componentName,
      componentInstanceId: alarm.componentInstanceId,
      componentInstanceName: alarm.componentInstanceName,
      conditionType: alarm.conditionType,
      groupName: alarm.groupName,
      id: alarm.id,
      parentConfigId: alarm.parentConfigId,
      // isDeleted: alarm.is_deleted,
      isOverride: alarm.isOverride,
      latch: alarm.latch,
      message: alarm.message,
      // rangeMax: alarm.range_max, // ????
      // rangeMin: alarm.range_min, // ????
      reAlarm: alarm.reAlarm,
      recommendedAction: alarm.recommendedAction,
      rocValue: alarm.roc_value, // ????
      setpoint: alarm.setpoint,
      severity: alarm.severity,
      tagId: alarm.tagId,
      tagName: alarm.tagName,
      time: alarm.time,
      name: alarm.name,
      description: alarm.description,
      // eventConfigId: alarm.id,
      // eventConfigId: alarm.alarm_config_id, // ????
      eventConfigType: alarm.eventConfigType,
      isEnabled: alarm.isEnabled || false
    };

    assetAlarms.push(objAlarmsGrid);
  });

  return assetAlarms;
}

export function getComponentInstAlarms(components: ComponentsByEntityId[]) {
  // console.log('components :>> ', components);
  return components.reduce((alarms, component) => {
    const compInstAlarms = component.model_component_instances?.reduce((alarmList, compInst) => {
      const componentName = compInst.entities_component.entity?.name;
      const componentId = compInst.entities_component.entity?.id;
      const tagEventConfig = compInst.entities_component?.entity?.alarmsConfigsByComponentId || [];
      const compAlarms = tagEventConfig.map(config =>
        ({
          ...getAlarm(config),
          componentName,
          componentId,
          componentInstanceId: compInst.component_instance_id,
          componentInstanceName: compInst.name,
          disableDeleteAction: true,
          ...getWriteback(config)
        })
      );

      return [...alarmList, ...compAlarms];
    }, []);

    return [...alarms, ...compInstAlarms];
  }, []);
}

function getWriteback(config: AlarmsConfigsInterface) {
  if(config.event_config?.event_actions && Object.keys(config.event_config?.event_actions['writeback'] || {}).length > 0) {
    const writeback = config.event_config?.event_actions['writeback'];
    return {
      writeback: writeback,
      writebackTagId: writeback['tagId'],
      writebackTagValue: writeback['value'],
      isWriteback: Object.keys(writeback || {}).length > 0,
    }
  }

  return {};
}
